module.exports = __webpack_public_path__ + "static/media/warranty.e7798a46.png";